import { render } from "./ErrorMessageItem.vue?vue&type=template&id=8d5ef1d0&ts=true"
import script from "./ErrorMessageItem.vue?vue&type=script&lang=ts"
export * from "./ErrorMessageItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__